module.exports = __webpack_public_path__ + "img/center.bdb1b018.svg";